import Constants from '../utils/consts';
import Cookies from 'universal-cookie';
import Utils from '../utils/utils';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function correggiTest(uname, token, id_test, durata, risposte) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'correggiTest.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            var resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });
        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'id': id_test,
            'risposte': risposte,
            'durata': durata,
            'db_name': db
        });
        console.log(postData);

        req.write(postData);

        req.end();

        
    });
}
